/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { EntityId } from '../../types/api/EntityId';
import { Organization } from '../../types/organization/Organization';
import { OrganizationActions, OrganizationActionTypes, OrganizationsActionTypes } from './types';

export const fetchOrganizations = (): OrganizationsActionTypes => ({
  type: OrganizationActions.ORGANIZATIONS_WATCHER,
});

export const fetchOrganizationsActions = {
  request: (): OrganizationsActionTypes => ({
    type: OrganizationActions.ORGANIZATIONS_REQUEST,
  }),
  success: (options: Organization[]): OrganizationsActionTypes => ({
    type: OrganizationActions.ORGANIZATIONS_SUCCESS,
    payload: { options },
  }),
  error: (errorMessage?: string): OrganizationsActionTypes => ({
    type: OrganizationActions.ORGANIZATIONS_FAILURE,
    payload: { errorMessage },
  }),
};

// Get the organization details from id
export const fetchOrganization = (organizationId: EntityId): OrganizationActionTypes => ({
  type: OrganizationActions.ORG_DETAILS_WATCHER,
  payload: { organizationId },
});

export const fetchOrganizationActions = {
  request: (): OrganizationActionTypes => ({
    type: OrganizationActions.ORG_DETAILS_REQUEST,
  }),
  success: (organization: Organization): OrganizationActionTypes => ({
    type: OrganizationActions.ORG_DETAILS_SUCCESS,
    payload: {
      organization,
    },
  }),
  error: (errorMessage?: string): OrganizationActionTypes => ({
    type: OrganizationActions.ORG_DETAILS_FAILURE,
    payload: {
      errorMessage,
    },
  }),
};
